import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {RootStore} from "../../../../configureStore";
import FieldWrapper from "../FieldWrapper";
import PreferredCourse from "./PreferredCourse";
const PreferredCourseWrapper: React.FC = () => {
    const masterFields = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.masterFields,
    );
    const bachelorFields = useSelector(
        (state: RootStore) => state.RegistrationLoginPage.bachelorFields,
    );
    const phdFields = useSelector((state: RootStore) => state.RegistrationLoginPage.phdFields);
    const level = useSelector((state: RootStore) => state.RegistrationLoginPage.level);

    const preferredCourse = level
        ? level === "Bachelors"
            ? bachelorFields?.preferredCourseV1
            : level === "Masters"
            ? masterFields?.preferredCourseV1
            : phdFields?.preferredCourseV1
        : undefined;
    return useMemo(() => {
        if (preferredCourse) {
            return (
                <FieldWrapper
                    visible={preferredCourse.visible}
                    loading={preferredCourse.loading ?? false}
                >
                    <PreferredCourse configuration={preferredCourse} />
                </FieldWrapper>
            );
        }
        return null;
    }, [preferredCourse]);
};
export default PreferredCourseWrapper;
